import { createFileRoute } from "@tanstack/react-router"
import { usePageTracking } from "~/hooks/usePageTracking"
import ReplenishmentSuggestions from "~/pages/procurement/order-suggestions"

export const Route = createFileRoute(
  "/_auth/procurement/order-suggestions/_layout/replenishment-suggestions",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Order Suggestions Replenishment")
  return <ReplenishmentSuggestions />
}
